export const LOQATE_BASE_URL = 'https://api.addressy.com/Capture/Interactive';
export const LOQATE_RETRIEVE_URL = 'Retrieve/v1/json3.ws';
export const LOQATE_FIND_URL = 'Find/v1.10/json3.ws';
